const messages = {
    StockAdded: 'Adicionado',
    StockRemoved: 'Eliminado',
    Surgery: 'Cirugía',
    Cosmetology: 'Cosmetología',
    Dispatch: 'Despacho',
    TpvSale: 'Venta',
    TpvSaleItemCancelled: 'Venta Cancelada',
    updateStock: 'Actualizar inventario',
    transferStock: 'Transferir inventario',
    showRecords: 'Mostrar historial',
    showInventoryByOffice: 'Mostrar inventario por oficina',
    Attention: 'Atención',
    Notification: 'Notificación',
    'Barcode lookup failed. Please try again or contact support.':
        'La búsqueda del código de barras falló. Inténtelo de nuevo o comuníquese con soporte.',
    'Barcode Invalid. Please enter or scan it again.':
        'Código de barras inválido. Ingréselo o escanéelo de nuevo.',
    'Please enter or scan a barcode.': 'Ingrese o escanee un código de barras.',
};

export default messages;
